
import { createContext, useContext, useState, useEffect } from "react";
import axiosInstance from "../axiosInterceptor";
const PermissionContext = createContext();
const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState({
    pages: [],
    actions: {}
  });

  const [accessToken, setAccessToken] = useState(localStorage.getItem("AlEzziAdminToken"));
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const fetchPermissions = async () => {
      if (!accessToken) {
        setLoading(false);
        return;
      }

      try {
        const res = await axiosInstance.get(
          "permission/getPermissionById"
        );

        const data = res.data.data;

        const pages = data.map((p) =>
          p?.pageId?.pageName?.toLowerCase()
        );

        const actions = {};

        data.forEach((p) => {
          const pageName =
            p?.pageId?.pageName?.toLowerCase();

          // IMPORTANT: API field is "action", not "actions"
          actions[pageName] = p?.action || [];
        });

        setPermissions({
          pages,
          actions,
        });
      } catch (err) {
        console.error("Permission fetch error:", err);
        setPermissions({
          pages: [],
          actions: {},
        });
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [accessToken]);
  return (
    <PermissionContext.Provider
      value={{ permissions, setAccessToken, loading }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);

export default PermissionProvider;